import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "../styles/main.css";

function OrderStation() {
  const navigate = useNavigate();

  const [userId, setUserId] = useState("");
  const [user, setUser] = useState(null);

  const [value, setValue] = useState("");
  const [side, setSide] = useState("Buy");

  const [loadingUser, setLoadingUser] = useState(false);
  const [loadingOrder, setLoadingOrder] = useState(false);

  const [error, setError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [orderResult, setOrderResult] = useState(null);

  const token = localStorage.getItem("token");

  const loadUser = async () => {
    if (!userId) {
      setError("شناسه کاربر را وارد کنید");
      return;
    }

    setLoadingUser(true);
    setError("");
    setSuccessMessage("");
    setUser(null);
    setOrderResult(null);

    try {
      const response = await axios.get(
        "https://enduserapi.armanitala.com/api/v1/Users/" + userId,
        {
          headers: {
            Authorization: "Bearer " + token,
            accept: "text/plain",
          },
        }
      );

      setUser(response.data.data);
    } catch (err) {
      setError(
        err?.response?.data?.message ||
          "کاربر مورد نظر پیدا نشد"
      );
    } finally {
      setLoadingUser(false);
    }
  };

  const submitOrder = async (e) => {
    e.preventDefault();

    if (!user) {
      setError("ابتدا کاربر را جستجو کنید");
      return;
    }

    if (!value || Number(value) <= 0) {
      setError("مقدار سفارش را وارد کنید");
      return;
    }

    setLoadingOrder(true);
    setError("");
    setSuccessMessage("");
    setOrderResult(null);

    try {
      const response = await axios.post(
        "https://enduserapi.armanitala.com/api/v1/Station",
        {
          userId: Number(userId),
          value: Number(value),
          side,
        },
        {
          headers: {
            Authorization: "Bearer " + token,
            "Content-Type": "application/json-patch+json",
          },
        }
      );

      setOrderResult(response.data.data);
      setSuccessMessage("سفارش با موفقیت ثبت شد");
    } catch (err) {
      setError(
        err?.response?.data?.message ||
          "خطا در ثبت سفارش"
      );
    } finally {
      setLoadingOrder(false);
    }
  };

  return (
    <div className="station-container">
      <button
        className="back-button"
        onClick={() => navigate("/dashboard")}
      >
        بازگشت به داشبورد
      </button>

      <h1>🏆 ایستگاه ثبت سفارش ادمین</h1>

      {error && <p className="error">{error}</p>}

      {successMessage && (
        <div className="success-message">
          {successMessage}
        </div>
      )}

      <div className="station-card">
        <h3>🔍 جستجوی مشتری</h3>

        <div className="station-search">
          <input
            type="number"
            placeholder="شناسه کاربر"
            value={userId}
            onChange={(e) => setUserId(e.target.value)}
          />

          <button
            type="button"
            onClick={loadUser}
            disabled={loadingUser}
          >
            {loadingUser
              ? "در حال جستجو..."
              : "جستجوی کاربر"}
          </button>
        </div>

        {user && (
          <>
            <div className="station-user-info">
              <div className="station-user-item">
                <strong>نام و نام خانوادگی</strong>
                <br />
                {user.fullName || "-"}
              </div>

              <div className="station-user-item">
                <strong>شناسه کاربر</strong>
                <br />
                {user.id}
              </div>

              <div className="station-user-item">
                <strong>نام کاربری</strong>
                <br />
                {user.userName}
              </div>

              <div className="station-user-item">
                <strong>ایمیل</strong>
                <br />
                {user.email || "-"}
              </div>

              <div className="station-user-item">
                <strong>موجودی طلا</strong>
                <br />
                {Number(
                  user.dailyBalanceInGold || 0
                ).toLocaleString()}
              </div>

              <div className="station-user-item">
                <strong>وضعیت حساب</strong>
                <br />
                {user.isActive ? "فعال" : "غیرفعال"}
              </div>
            </div>

            <form
              className="station-form"
              onSubmit={submitOrder}
            >
              <input
                type="number"
                step="0.001"
                placeholder="مقدار طلا"
                value={value}
                onChange={(e) => setValue(e.target.value)}
                required
              />

              <select
                value={side}
                onChange={(e) => setSide(e.target.value)}
              >
                <option value="Buy">خرید</option>
                <option value="Sell">فروش</option>
              </select>

              <button
                type="submit"
                disabled={loadingOrder}
              >
                {loadingOrder
                  ? "در حال ثبت سفارش..."
                  : "ثبت سفارش"}
              </button>
            </form>
          </>
        )}
      </div>

      {orderResult && (
        <div className="station-result">
          <h3>📋 اطلاعات سفارش ثبت شده</h3>

          <div className="station-result-grid">
            <div className="station-result-item">
              <strong>کد سفارش</strong>
              <br />
              {orderResult.id}
            </div>

            <div className="station-result-item">
              <strong>نام کاربر</strong>
              <br />
              {orderResult.user?.fullName}
            </div>

            <div className="station-result-item">
              <strong>نوع سفارش</strong>
              <br />
              {orderResult.side}
            </div>

            <div className="station-result-item">
              <strong>دارایی</strong>
              <br />
              {orderResult.asset}
            </div>

            <div className="station-result-item">
              <strong>وزن طلا</strong>
              <br />
              {orderResult.goldWight}
            </div>

            <div className="station-result-item">
              <strong>قیمت هر گرم</strong>
              <br />
              {Number(
                orderResult.price || 0
              ).toLocaleString()}
            </div>

            <div className="station-result-item">
              <strong>مبلغ کل</strong>
              <br />
              {Number(
                orderResult.totalAmount || 0
              ).toLocaleString()}
            </div>

            <div className="station-result-item">
              <strong>وضعیت سفارش</strong>
              <br />
              {orderResult.orderStatus}
            </div>

            <div className="station-result-item">
              <strong>وضعیت تسویه</strong>
              <br />
              {orderResult.orderSettleStatus}
            </div>

            <div className="station-result-item">
              <strong>تاریخ ثبت</strong>
              <br />
              {new Date(
                orderResult.createdDate
              ).toLocaleString("fa-IR")}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default OrderStation;